<template>
    <div>
        <v-navigation-drawer
                v-model="drawer"
                clipped
                fixed
                app
        >
            <v-list dense>
                <v-list-tile to="/" exact>
                    <v-list-tile-action>
                        <v-icon>dashboard</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Dashboard</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/calendar" exact>
                    <v-list-tile-action>
                        <v-icon>calendar_today</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Agenda</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/subscriptions" exact>
                    <v-list-tile-action>
                        <v-icon>person</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Abonnementen</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <!--<v-list-tile to="/tickets" exact>
                    <v-list-tile-action>
                        <v-icon>local_play</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Tickets</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>-->
                <v-list-group
                        sub-group
                        no-action
                        value="true"
                >
                    <v-list-tile slot="activator">
                        <v-list-tile-title>Admin</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile to="/admin/tribunes">
                        <v-list-tile-title>Tribunes</v-list-tile-title>
                        <v-list-tile-action>
                            <v-icon>view_comfy</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list-group>
                <v-divider></v-divider>
                <v-list-tile to="/match/" disabled>
                    <v-list-tile-action>
                        <v-icon>event</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Huidige wedstrijd</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/report/" disabled>
                    <v-list-tile-action>
                        <v-icon>event</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Rapport van wedstrijd</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/subscription-report/">
                    <v-list-tile-action>
                        <v-icon>event</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Rapport van abonnementen</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app fixed clipped-left>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>Ticketing</v-toolbar-title>
        </v-toolbar>
    </div>
</template>

<script>
export default {
  name: "MainMenu",
  props: {
    active: String
  },
  data: () => ({
    drawer: true,
    currentYear: new Date().getFullYear()
  })
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
